export const DEALS_ROUTE = "/deals";

export const DEAL_TYPE_OPTIONS = [
    { label: "Monthly Business Guarantee", value: "MONTHLY_BUSINESS_GUARANTEE" },
    { label: "Slabwise Commercials", value: "SLABWISE_COMMERCIALS" },
    { label: "Revenue Sharing", value: "REVENUE_SHARING" },
];

export const DURATION_OPTIONS = [
    { label: "Yearly", value: "YEARLY" },
    { label: "Monthly", value: "MONTHLY" },
    { label: "Weekly", value: "WEEKLY" },
    { label: "Custom", value: "CUSTOM" },
];

export const AGREEMENT_STATUS_OPTIONS = [
    { label: "Pending", value: "PENDING" },
    { label: "Signed", value: "SIGNED" },
    { label: "Expired", value: "EXPIRED" },
];

export const API_INTEGRATION_STATUS_OPTIONS = [
    { label: "Pending", value: "PENDING" },
    { label: "Shared", value: "SHARED" },
    { label: "Under Process", value: "UNDER_PROCESS" },
    { label: "Testing", value: "TESTING" },
    { label: "Completed", value: "COMPLETED" },
];

export const AGREEMENT_TYPE_OPTIONS = [
    { label: "Upload", value: "upload" },
    { label: "Field", value: "field" },
];

export const COMMERCIAL_MODEL_KEYS = [
    "Revenue Share (%)",
    "Minimum Business Guarantee",
    "Slabwise Commercial (if applicable)",
    "Commercial Included (Yes / No)",
    "GST Applicable (Yes / No)",
];

export const RSA_SERVICE_OPTIONS = [
    "Towing",
    "Battery Jumpstart",
    "Flat Tyre Assistance",
    "Fuel Delivery",
    "Minor Repair",
    "Lockout Assistance",
];

export const TOWING_VEHICLE_TYPES = [
    "2W",
    "Hatchback",
    "Sedan",
    "SUV",
    "Luxury Vehicle",
];
